import { BlogPost } from "@/content/blog";

export const RELATED_POSTS: Record<string, string[]> = {
  // Services
  "seo": ["how-to-rank-in-ai-overviews", "local-seo-checklist-2026", "technical-seo-indexing-monitoring"],
  "local-seo": ["local-seo-checklist-2026", "dallas-seo-case-study", "how-to-rank-in-ai-overviews"],
  "technical-seo": ["technical-seo-indexing-monitoring", "ai-search-optimization-guide", "how-to-rank-in-ai-overviews"],
  "content-marketing": ["how-to-rank-in-ai-overviews", "local-seo-checklist-2026", "technical-seo-indexing-monitoring"],
  "ai-search": ["how-to-rank-in-ai-overviews", "ai-search-optimization-guide", "dallas-seo-case-study"],
  
  // Locations
  "austin": ["how-to-rank-in-ai-overviews", "local-seo-checklist-2026", "technical-seo-indexing-monitoring"],
  "dallas": ["dallas-seo-case-study", "local-seo-checklist-2026", "how-to-rank-in-ai-overviews"],
  "plano": ["dallas-seo-case-study", "technical-seo-indexing-monitoring", "local-seo-checklist-2026"],
  "cedar-park": ["local-seo-checklist-2026", "how-to-rank-in-ai-overviews", "technical-seo-indexing-monitoring"],
  "round-rock": ["local-seo-checklist-2026", "technical-seo-indexing-monitoring", "how-to-rank-in-ai-overviews"],
  "georgetown": ["local-seo-checklist-2026", "how-to-rank-in-ai-overviews", "technical-seo-indexing-monitoring"],
  "pflugerville": ["local-seo-checklist-2026", "technical-seo-indexing-monitoring", "how-to-rank-in-ai-overviews"],
  "west-lake-hills": ["how-to-rank-in-ai-overviews", "local-seo-checklist-2026", "technical-seo-indexing-monitoring"],
  "bee-cave": ["local-seo-checklist-2026", "how-to-rank-in-ai-overviews", "technical-seo-indexing-monitoring"],
  "lakeway": ["local-seo-checklist-2026", "technical-seo-indexing-monitoring", "how-to-rank-in-ai-overviews"],
};
